export const shadows = {
    xs: '0px 1px 2px 0px rgba(0, 0, 0, 0.06)',
    sm: '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
    md: '0px 4px 8px 0px rgba(0, 0, 0, 0.16)',
    lg: '0px 8px 16px 0px rgba(0, 0, 0, 0.20)',
    xl: '0px 12px 24px 0px rgba(0, 0, 0, 0.24)',
    card: '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
    cardHover: '0px 4px 8px 0px rgba(0, 0, 0, 0.16)',
    button: '0px 2px 4px 0px rgba(0, 0, 0, 0.12)',
};
